module.exports = __webpack_public_path__ + "static/media/galeria_elo_05.60fec708.jpg";